export const FeedbackRatings = [1, 2, 3, 4, 5];
export const FeedbackRatingsDetails = [1, 2, 3];
export const FeedbackRatingsLoanAppCompletion = 0.8;

export const FeedbackTypeMap = { "SignUp": "SU", "LoanApplication": "AF" };
export const FeedbackTypeVarMap = { "SignUp": "sign_up", "LoanApplication": "app_form" };

export const FeedbackPages = {
    "SignUp": ["/dashboard", "/dashboard/applications"],
    "LoanApplication": [
        "/loans/:loan_id/draft/edit",
        "/loans/:loan_id/draft/edit/:section",
        "/loans/:loan_id/draft/edit/:section/:sub_section",
    ],
};
